<template>
  <div>
    <v-tabs color="secondary" dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab v-for="(item, i) in tabs" :key="i" @click="way = item.way">
        <v-icon>{{item.icon}}</v-icon>
        &nbsp; &nbsp;
        {{item.name}}
      </v-tab>
    </v-tabs>
    <Categories v-if="isCategory" @category="category = $event"></Categories>
    <Item :category="category" v-show="way === 'item'" />
    <List v-show="way === 'list'" />
  </div>
</template>
<script>
import Item from "../shopping/Item";
import List from "../shopping/List";
import Categories from "@/shopping/Categories";
export default {
  components: {Categories, Item, List },
  data() {
    return {
      way: "item",
      isCategory: true,
      category: {},
      tabs: [
        {
          name: "Item",
          way: "item",
          icon: "shopping_basket"
        },
        {
          name: "Order List",
          way: "list",
          icon: "reorder"
        }
      ]
    };
  },
  computed: {
    isEnabled() {
      return this.$store.getters.shoppingenable;
    }
  },
  methods: {
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    }
  },
  mounted() {
    const vm = this;
    if (!vm.isEnabled) vm.$router.replace("/settings");
  }
};
</script>

<style>
</style>